import ApiClient from "@subly/s1/core/client";

const client = new ApiClient(import.meta.env.VITE_HOST + "/api");

export default client;